// Ingestion runs route (/ops/runs): typed status and document filters in the URL; the screen is RunsPage.
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { zRunStatus } from "@/api/__generated__/zod.gen";
import { optionalString, optionalList } from "@/app/search";
import { RunsPage } from "@/features/operations/RunsPage";

const zRunStatusFilter = z.union([zRunStatus, z.literal("interrupted")]);

const searchSchema = z.object({
  doc: optionalString(),
  status: optionalList(zRunStatusFilter),
});

export const Route = createFileRoute("/_app/ops/runs/")({
  validateSearch: searchSchema,
  staticData: { crumb: "Runs & jobs" },
  component: RunsPage,
});
